/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'primereact/checkbox';
import { getAllMessages } from '../../reducers/wca/sales-support/sales-support-action';
import { useSocket } from '../../hooks/useSocket';
import { useUtility } from '../../context/UtilityContext';
import Message from './Message';
import ForwardMessagesModal from '../../components/ForwardMessagesModalWCA/ForwardMessagesModal';
import {
  clearForwardFirstMessageId,
  clearForwardMessage,
  setForwardMessage,
} from '../../reducers/wca/sales-support/sales-support-slice';
import { ReactComponent as ShareSvg } from '../../assets/svgIcons/svgIcons/whatsappForward.svg';
import { formatWcaMessage } from '../../utils/chatUtils';

const PAGE_LIMIT = 30;

const Messages = () => {
  const dispatch = useDispatch();
  const scrollRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]); // flat array of normalized messages
  const [lastMessageId, setLastMessageId] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [grouped, setGrouped] = useState({});
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [selectedMessagesContent, setSelectedMessagesContent] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const { selectedMetadataId } = useUtility();
  const {
    chatId,
    forwardMessagesFlag,
    clickedForwardFirstMessageId,
    selectedForwardMessagesContent,
    user,
  } = useSelector((s) => s.wcaEnqChats);

  let companyKey = JSON.parse(localStorage.getItem('companykey'));
  const { socket } = useSocket(companyKey?.id, selectedMetadataId, chatId);

  const fetchMessages = async (lastId = 0) => {
    if (!chatId) return;
    setLoading(true);

    try {
      const payload = {
        metadataid: selectedMetadataId,
        phone: chatId,
        lastMessageId: lastId,
        limit: PAGE_LIMIT,
      };

      const res = await dispatch(getAllMessages(payload)).unwrap();

      const rows = res?.data?.messages || res?.rows || res?.data || [];

      const normalized = rows
        ?.map(formatWcaMessage)
        ?.sort((a, b) => a.finalTimestamp - b.finalTimestamp);

      if (lastId === 0) {
        setMessages(normalized);
      } else {
        setMessages((prev) => [...normalized, ...prev]);
      }

      // UPDATE lastMessageId FOR NEXT PAGINATION
      if (normalized.length > 0) {
        const oldest = normalized[0];
        setLastMessageId(oldest.id);
      }

      setHasMore(normalized.length === PAGE_LIMIT);
    } catch (err) {
      console.error('fetchMessages error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages(0);
    return () => {};
  }, []);

  // initial load + socket join

  useEffect(() => {
    if (!socket) return;

    const onNewMessage = (rawMsg) => {
      console.log(`✅ Socket connected messages ${user?.whatsappName}:`, socket.id);
      const m = formatWcaMessage(rawMsg);
      setMessages((prev) => [...prev, m]);

      const atBottom =
        scrollRef.current &&
        scrollRef.current.scrollHeight - scrollRef.current.scrollTop <=
          scrollRef.current.clientHeight + 50;

      if (atBottom) {
        setTimeout(() => scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight), 60);
      }
    };

    socket.on('new_message', onNewMessage);
    setInitialLoad(true);
    fetchMessages(0);

    return () => {
      socket.off('new_message', onNewMessage);
    };
  }, [socket, selectedMetadataId, chatId]);

  useEffect(() => {
    if (!socket) return;
    const onStatusUpdate = (data) => {
      const msgId = data.msgId;

      setMessages((prevMessages) =>
        prevMessages.map((msg) => {
          const id = msg.msgId || msg.id || msg._id;
          if (id !== msgId) return msg;

          const updated = { ...msg };

          updated.messageStatus = {
            ...updated.messageStatus,
            sent: !!data.sent,
            delivered: !!data.delivered,
            read: !!data.read,
            failed: data.failed || null,
          };

          updated.isSent = !!data.sent;
          updated.isDelivered = !!data.delivered;
          updated.isRead = !!data.read;

          if (data.failed) {
            updated.status = 'failed';
          }

          return updated;
        }),
      );
    };

    socket.on('message_status_update', onStatusUpdate);

    return () => {
      socket.off('message_status_update', onStatusUpdate);
    };
  }, [socket, selectedMetadataId, chatId]);

  useEffect(() => {
    if (!socket) return;

    const onReactionUpdate = (raw) => {
      const inbound = raw?.inboundReaction;
      const outbound = raw?.outboundReaction;

      const reactionObj = inbound || outbound;
      if (!reactionObj) return;

      const reactedMsgId = reactionObj?.reaction?.message_id;
      const emoji = reactionObj?.reaction?.emoji;

      if (!reactedMsgId || !emoji) return;

      const reactionKey = inbound ? 'inboundReaction' : 'outboundReaction';

      setMessages((prev) =>
        prev.map((msg) => {
          const localMsgId = msg.msgId;

          console.log('local Reaction update received:', reactedMsgId);
          console.log('local', localMsgId);
          console.log('ifff before');

          // Not the target message → skip
          if (localMsgId !== reactedMsgId) return msg;
          console.log('iffff after');
          // If already reacted → Update only emoji
          if (msg[reactionKey]) {
            return {
              ...msg,
              [reactionKey]: {
                ...msg[reactionKey],
                reaction: {
                  ...msg[reactionKey].reaction,
                  emoji,
                },
              },
            };
          }

          // Otherwise create new reaction object
          return {
            ...msg,
            [reactionKey]: {
              id: reactionObj.id,
              from: reactionObj.from,
              type: 'reaction',
              reaction: {
                emoji,
                message_id: reactedMsgId,
              },
              timestamp: reactionObj.timestamp,
            },
          };
        }),
      );
    };

    socket.on('reaction_update', onReactionUpdate);
    return () => socket.off('reaction_update', onReactionUpdate);
  }, [socket, selectedMetadataId, chatId]);

  // load older messages (pagination)
  const loadOlder = () => {
    if (!hasMore || loading) return;

    const previousScrollHeight = scrollRef.current?.scrollHeight || 0;

    fetchMessages(lastMessageId).finally(() => {
      // restore scroll position after older messages are prepended
      setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight - previousScrollHeight;
        }
      }, 80);
    });
  };

  const onScroll = () => {
    if (scrollRef.current?.scrollTop === 0) {
      loadOlder();
    }
  };

  // group messages by date for rendering
  useEffect(() => {
    const map = {};
    const todayString = new Date().toDateString();
    messages.forEach((m) => {
      const d = new Date(m.finalTimestamp);
      const key =
        d.toDateString() === todayString
          ? 'Today'
          : `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(
              2,
              '0',
            )}-${d.getFullYear()}`;

      if (!map[key]) map[key] = [];
      map[key].push(m);
    });
    setGrouped(map);

    // scroll to bottom after initial load
    if (initialLoad) {
      setTimeout(() => {
        scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight);
        setInitialLoad(false);
      }, 120);
    }
  }, [messages]);

  const toggleSelectMessage = (message) => {
    if (selectedMessages.length === 5 && !selectedMessages.includes(message.msgId)) {
      return; // Do not allow selecting more messages
    }
    setSelectedMessages((prevSelectedMessages) => {
      let updatedSelectedMessages;
      if (prevSelectedMessages && prevSelectedMessages.includes(message.msgId)) {
        updatedSelectedMessages = prevSelectedMessages.filter((id) => id !== message.msgId);
      } else {
        updatedSelectedMessages = [...(prevSelectedMessages || []), message?.msgId];
      }
      setSelectedMessagesContent((prevSelectedMessagesContent) => {
        let updatedSelectedMessagesContent;
        if (
          prevSelectedMessagesContent &&
          prevSelectedMessagesContent.find((msg) => msg.msgId === message.msgId)
        ) {
          updatedSelectedMessagesContent = prevSelectedMessagesContent.filter(
            (msg) => msg.msgId !== message.msgId,
          );
        } else {
          updatedSelectedMessagesContent = [...(prevSelectedMessagesContent || []), message];
        }
        return updatedSelectedMessagesContent;
      });
      return updatedSelectedMessages;
    });
  };

  useEffect(() => {
    if (clickedForwardFirstMessageId) {
      const msg = messages.find(
        (m) => (m.msgId || m.gsId || m.id || m._id) === clickedForwardFirstMessageId,
      );
      // if (msg) toggleMsg(msg);
      if (msg) toggleSelectMessage(msg);
    }
  }, [clickedForwardFirstMessageId, messages]);

  const forwardMessages = () => {
    dispatch(
      setForwardMessage({
        forwardMessagesFlag: false,
        selectedForwardMessagesContent: selectedMessagesContent,
      }),
    );
    setShowShareModal(true);
    setSelectedMessages([]);
    setSelectedMessagesContent([]);
    dispatch(clearForwardFirstMessageId());
  };

  const closeForward = () => {
    dispatch(clearForwardMessage());
    setShowShareModal(false);
    setSelectedMessages([]);
    setSelectedMessagesContent([]);
  };

  return (
    <div className="messages flex-grow-1 overflow-y-auto" ref={scrollRef} onScroll={onScroll}>
      {!messages.length && !loading && (
        <div className="text-center mt-3">Start chat to view messages</div>
      )}

      {hasMore && !loading && (
        <div className="w-full flex justify-content-center mb-4 mt-3 __line">
          <button className="__loadBtn" onClick={loadOlder}>
            Load History
          </button>
        </div>
      )}

      {loading && (
        <div className="text-center">
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }} />
        </div>
      )}

      {Object.keys(grouped).map((dateKey) => (
        <div key={dateKey}>
          <div className="w-full flex justify-content-center">
            <span className="__dateView">{dateKey}</span>
          </div>

          {grouped[dateKey].map((m, idx) =>
            !forwardMessagesFlag ? (
              <Message message={m} key={m.gsId || idx} key_id={idx} />
            ) : (
              <div
                key={m.gsId || idx}
                className={`flex align-items-center p-1 mt-1 ${
                  selectedMessages.includes(m.msgId || m.gsId || m.id || m._id)
                    ? 'selectedMessage'
                    : ''
                }`}
              >
                <Checkbox
                  checked={selectedMessages.includes(m.msgId || m.gsId || m.id || m._id)}
                  onChange={() => toggleSelectMessage(m)}
                />
                <div className="w-12 m-0">
                  <Message message={m} key_id={idx} />
                </div>
              </div>
            ),
          )}
        </div>
      ))}

      {forwardMessagesFlag && (
        <div className="h-4rem mb-2 px-4 flex justify-content-between align-items-center surface-100">
          <div onClick={closeForward}>
            <i className="pi pi-times" style={{ fontSize: '1.125rem' }} />
          </div>
          {selectedMessages.length} selected
          {selectedMessages.length > 0 && (
            <div style={{ width: '1.125rem', cursor: 'pointer' }} onClick={forwardMessages}>
              <ShareSvg />
            </div>
          )}
        </div>
      )}

      {showShareModal && (
        <ForwardMessagesModal
          selectedMessages={selectedForwardMessagesContent}
          onClose={() => setShowShareModal(false)}
        />
      )}
    </div>
  );
};
export default Messages;
/* eslint-enable */
